import styled from '@emotion/styled'
import { unifiedColors } from 'styles/colors'
import { theme, themeUtils } from 'styles/theme'

export const GridEventContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  ${themeUtils.maxWidth.md} {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  ${themeUtils.maxWidth.sm} {
    padding: 17px 15px;
  }

  font-weight: ${themeUtils.fontWeights.regular};
  padding: 34px 32px;
  justify-content: space-between;
  border-radius: 20px;
  background-color: ${unifiedColors.surface.subdued};
`

export const InfoEventContent = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;
`

export const CapsEventContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.palette.surface.default};
  border-radius: 7px;
  min-width: 48px;
  min-height: 48px;
`

export const CapsDateEventContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  ${themeUtils.bodySmallSemiBold}
  padding: 7px 9px;
`

export const CapsIconPlaceEventContent = styled.div`
  text-align: center;
`

export const CapsIconGroupEventContent = styled.div`
  text-align: center;
  padding: 9px;
`

export const EditorEventContent = styled.div`
  grid-column: 1 / -1;

  a {
    color: ${theme.palette.label.default};
  }

  ul {
    padding-left: 20px;
  }
`
